/* The organisation's actual logo (miner with pick & hammer over strata
 * stripes + "Small Scale Miners Zambia" wordmark) - sourced from the brand
 * folder ("05 Brand & Documents/logo.png") and served from /brand/logo.png.
 * Replaces the hand-drawn stand-in mark this component used to render.
 *
 * The artwork carries the organisation name inside itself, so the old
 * side-text is gone; `tagline` survives as a small caption under the image
 * for callers that brand a context (e.g. StaffBadge's "Staff ID"). The
 * image sits on its own white rounded chip so it stays legible on dark
 * surfaces (login hero, staff badge, dark mode) as well as light ones.
 */
export function Logo({
  tone = 'default', tagline,
}: { tone?: 'default' | 'onDark'; tagline?: string }) {
  return (
    <span className="logo" style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <img
        src="/brand/logo.png"
        alt="Small Scale Miners Zambia"
        style={{
          height: 44, width: 'auto', display: 'block',
          background: '#fff', borderRadius: 8, padding: 2,
        }}
      />
      {tagline && (
        <span style={{
          fontSize: 10, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase',
          color: tone === 'onDark' ? 'rgba(255,255,255,.85)' : 'var(--text-muted)',
        }}>
          {tagline}
        </span>
      )}
    </span>
  )
}
